import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import {
	updateMedia,
	deleteMedia,
	createMedia,
	createLibrary,
	deleteLibrary,
} from '@/redux/actions';
import { useNavigate } from 'react-router-dom';

const WS_MEDIA_BY_HTTP = {
	CREATE: 'media/:eventID/POST',
	DELETE: 'media/:mediaID/DELETE',
	UPDATE: 'media/:mediaID/PATCH',
	CREATE_LIBRARY: 'media/:eventID/library/POST',
	DELETE_LIBRARY: 'library/:libraryID/DELETE',
};

const EventMediaSubscriptions = props => {
	const {
		socket,
		currentEventId,
		updateMedia,
		deleteMedia,
		createMedia,
		createNewLibrary,
		deleteLibrary,
	} = props;
	const navigate = useNavigate();
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribe = () => {
		socket.emit('event/:eventID/media/SUBSCRIBE', { eventID: currentEventId });
	};

	const unsubscribe = () => {
		socket.emit('event/:eventID/media/UNSUBSCRIBE', { eventID: currentEventId });
	};

	const listenForCreatedMedia = () => {
		socket.on(WS_MEDIA_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error creating media', error);
			else {
				const { name } = data;
				createMedia(data);
				displayMessage(`${name} has been uploaded`);
			}
		});
	};

	const listenForUpdatedMedia = () => {
		socket.on(WS_MEDIA_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating media', error);
			else {
				const { name, id } = data;
				updateMedia(data);
				displayMessage(`${name} (${id}) has been updated`);
			}
		});
	};

	const listenForDeletedMedia = () => {
		socket.on(WS_MEDIA_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error deleting media');
			else {
				const { mediaName } = data;
				deleteMedia(data);
				displayMessage(`${mediaName} deleted`);
			}
		});
	};

	const listenForCreatedLibrary = () => {
		socket.on(WS_MEDIA_BY_HTTP.CREATE_LIBRARY, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error creating library', error);
			else {
				const { createLibrary, socketID } = data;
				const { event_id, id, name } = createLibrary;
				createNewLibrary(createLibrary);
				if (socketID === socket.id) {
					navigate(`/events/${event_id}/library/${id}`);
				}
				displayMessage(`${name} library has been created`);
			}
		});
	};

	const listenForDeletedLibrary = () => {
		socket.on(WS_MEDIA_BY_HTTP.DELETE_LIBRARY, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error while deleting library', error);
			else {
				const { libraryName } = data;
				deleteLibrary(data);
				displayMessage(`${libraryName} Library deleted`);
			}
		});
	};

	const listeners = () => [
		listenForCreatedMedia,
		listenForDeletedMedia,
		listenForUpdatedMedia,
		listenForCreatedLibrary,
		listenForDeletedLibrary,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_MEDIA_BY_HTTP)}
				from="EventMediaSubscriptions"
			/>
			{React.cloneElement(props.children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	createMedia: media => dispatch(createMedia(media)),
	updateMedia: media => dispatch(updateMedia(media)),
	deleteMedia: mediaID => dispatch(deleteMedia(mediaID)),
	createNewLibrary: library => dispatch(createLibrary(library)),
	deleteLibrary: libraryID => dispatch(deleteLibrary(libraryID)),
});

export default connect(msp, mdp)(EventMediaSubscriptions);
